<template>
    <div>
        <Down v-if="isWeixins()" />
        <div :class="{'daily-list-panel':true,'iswx':isWeixins()}">
            <div v-if="$route.query.h" class="tab-test" :style="{'width': '100%','height': $route.query.h /100 + 'rem'}"></div>
            <div :class="{'daily-pro':true,'intelligence':type == 19 || type == 20}">
                 <!-- 顶部信息区域  -->
                <div :class="{'daily-product':true,'inteproduct':type == 19,'raderproduct':type == 20}">
                    <div :class="{'inte-back':true,'not-inte':type != 19 && type != 20}"></div>
                    <div class="daily-desc">{{dailyMap[type + '']}}介绍：{{info.description}}</div>
                    <template v-if="type == 19">
                        <div class="intelligence-card">
                            <div class="card">
                                <p class="cardicon"><i class="inte-core"></i></p>
                                <p class="cardname">核心机密</p>
                            </div>
                            <div class="card">
                                <p class="cardicon"><i class="inte-notice"></i></p>
                                <p class="cardname">通知提醒</p>
                            </div>
                            <div class="card">
                                <p class="cardicon"><i class="inte-sole"></i></p>
                                <p class="cardname">独家爆料</p>
                            </div>
                            <div class="card">
                                <p class="cardicon"><i class="inte-overall"></i></p>
                                <p class="cardname">全面及时</p>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                            <div class="focus">
                                <ul>
                                    <li>
                                        <div class="card">
                                            <div class="rader3"></div>
                                            <div class="content">
                                                <p class="title">覆盖全球 实时更新</p>
                                                <p class="desc">覆盖全球各大足、篮球赛事，每日实时捕捉最新重要信息</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card">
                                            <div class="rader1"></div>
                                            <div class="content">
                                                <p class="title">历史纪录 透视比赛</p>
                                                <p class="desc">搜集当日全球参赛球队、球员各类对比赛有参考价值的历史纪录</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card">
                                            <div class="rader2"></div>
                                            <div class="content">
                                                <p class="title">极限数据 规律总结</p>
                                                <p class="desc">精选对比赛有影响的极限数据，包含胜负、大小球、指数等多个维度</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card">
                                            <div class="rader3"></div>
                                            <div class="content">
                                                <p class="title">覆盖全球 实时更新</p>
                                                <p class="desc">覆盖全球各大足、篮球赛事，每日实时捕捉最新重要信息</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="card">
                                            <div class="rader1"></div>
                                            <div class="content">
                                                <p class="title">历史纪录 透视比赛</p>
                                                <p class="desc">搜集当日全球参赛球队、球员各类对比赛有参考价值的历史纪录</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <ol>
                                    <li class="current"></li>
                                    <li></li>
                                    <li></li>
                                </ol>
                        </div>
                    </template>
                    <div :class="{'daily-user-buy': true, 'none': buy_info.total == '0' || isHiscoress()}">
                        <span class="user-num">共{{buy_info.total}}人购买</span>
                        <template v-if="buy_info.avatar && buy_info.avatar.length > 0">
                            <span v-for="(item,index) in buy_info.avatar" :key="index" class="face"><img :src="item" /></span>
                        </template>
                    </div>
                    <div :class="{'daily-buy':true, 'ai':type == 6, 'gofollowservice': (type == 19 || type == 20) && (info.status == 1 || info.status == 2)}">
                        <template v-if="info && info.name">
                            <template v-if="info.status == 0 || info.status == -1 || info.status == 3">
                                <template v-if="behavior == 1 && info.status == 0">
                                    <span class="tags-expired">查看权限派发中，轻点查询按钮可进行刷新</span>
                                </template>
                                <template v-else>
                                    <span class="tags-expired">{{info.tags}}</span>
                                </template>
                                <template v-if="(type != 6 || type != 2 || type != 3 || type != 4 || type != 1)">
                                    <template v-if=" (isStorepacks() && (getAppVs() == 293))">
                                        <div></div>
                                    </template>
                                    <template v-else-if="behavior == 1 && info.status == 0">
                                        <span :class="{'daily-renew':true,'buyinte':type == 19}">查询</span>
                                    </template>
                                    <template v-else>
                                        <span  :class="{'daily-renew':true,'buyinte':type == 19 || type == 20}" >{{dataPrice[type]}}{{isStorepacks()?'元':'嗨币'}}/月</span>
                                    </template>
                                </template>
                            </template>
                            <template v-else-if="info.status == 6">
                                <span class="tags-expired ai">{{info.tags}}</span>
                            </template>
                            <template v-else>
                                <template v-if="type == 19">
                                    <span class="time-expired">有效期至：{{info.end_time && info.end_time.substring(2)}}{{diffDay()}}</span>
                                </template>
                                <template v-else>
                                    <span class="time-expired">有效期至：{{info.end_time && info.end_time.substring(0,10)}}{{diffDay()}}</span>
                                </template>
                                <template v-if="!isStorepacks() && (!getAppVs() == 293) && (type != 2 || type != 3 || type != 4 || type != 1)">
                                    <span :class="{'daily-renew':true,'isinte':(type == 19 || type == 20) && (info.status == 1 || info.status == 2) && !hiscores,'ishiscores':hiscores}" onClick={self.go_daily_buy.bind(self, type, true)}>续 费</span>
                                </template>
                                <div v-if="(type == 19 || type == 20) && (info.status == 1 || info.status == 2) && !hiscores" class="gotoservicehouse" onClick={self.goFollowServiceHouse.bind(self)}>关注服务号</div>
                            </template>
                        </template>
                    </div>
                </div>
                <div :class="{'daily-switch':true, 'none':type == 6 || type == 18 || type == 17 || type == 16 || type == 15 || type == 19 || type == 20 || type == 21 || type == 22}">
                    <div>
                        <span :class="{'current':true,'isSelect':isSelect == 1}" >历史推荐<em></em></span>
                    </div>
                    <div>
                        <span :class="{'current':true,'isSelect':isSelect == 2}">今日推荐<em></em></span>
                    </div>
                    <div>
                        <span :class="{'current':true,'isSelect':isSelect == 3}">明日预告<em></em></span>
                    </div>
                </div>
            </div>
            <!-- {/* 冷门分析tab切换 */} -->
            <div :class="{'ai-tab':true, 'none':type != 18 && type != 17 && type != 16 && type != 15 && type != 21 && type != 22}">
                <div onClick={self.switchModelTab.bind(self,1)}>
                    <span :class="modelActive == 1? 'active':''">{{type == 15 || type == 22?'历史推荐':'历史命中'}}<em></em></span>
                </div>
                <div onClick={self.switchModelTab.bind(self,2)}>
                    <span :class="modelActive == 2? 'active':''">今日推荐<em></em></span>
                </div>
            </div>
            <!-- {/* 冷门分析今日推荐总概、tab */} -->
            <div :class="{'cold-summary':true, 'clearfloat':true, 'none':(type!=18 && type!=17 && type!=15 && type!=21 &&type!=22) || (type==18&&modelActive==1) || (type==17&&modelActive==1) || (type==16&&modelActive==1) || (type==15&&modelActive==1) ||(type==21&&modelActive==1)||(type==22&&modelActive==1)|| (info.status==-1|| info.status==0 || info.status == 3)}">
                <div :class="{'summary-txt':true, 'none':type==21||type==22}">推荐总数:{{coldList && coldList.length}}场 {{modelupdatetime}}分钟前更新</div>
                <div :class="{'summary-txt':true, 'none':type!=21}">推荐总数:{{coldList && coldList.length}}场 每分钟更新</div>
                <div :class="{'summary-txt':true, 'none':type!=22}">推荐总数:{{coldList && coldList.length}}场 1分钟前更新</div>
                <!-- {/* 冷门 */} -->
                <div :class="{'summary-btn':true,'fl-r':true,'none':type==17 || type==16 || type==15 ||type==21||type==22}">
                    <div :class="commandActive == 1? 'active':''" onClick={self.coldcommandTab.bind(self,1)}>按时间</div>
                    <div :class="commandActive == 2? 'active':''" onClick={self.coldcommandTab.bind(self,2)}>按指数</div>
                </div>
                <!-- {/* 大数据 */} -->
                <div :class="{'summary-btn':true,'fl-r':true,'none':type==18 || type==17 || type==16 ||type==21||type==22}">
                    <div :class="commandActive == 1? 'active':''" onClick={self.bigcommandTab.bind(self,1)}>按时间</div>
                    <div :class="commandActive == 2? 'active':''" onClick={self.bigcommandTab.bind(self,2)}>按认可度</div>
                </div>
                <div :class="{'jc':true,'fl-r':true,'none':type!=21&&type!=22}">
                    <span class="jingcai">竞彩</span>
                    <input ref="jccheck" class='switch' type="checkbox"  />
                </div>
            </div>
            <!-- {/* 日历切换 */} -->
            <div :class="{'daily-calendar':true,'none':type==6 || type==19 || type == 20 || (type==18&&modelActive==2) || (type==17&&modelActive==2) || (type==15&&modelActive==2)||(type==21&&modelActive==2)||(type==22&&modelActive==2)}">
                <template v-if="getCookies('JH') && info.status != 0 && info.status != 3 && tomorrow_num  > 0">
                     <i class="matchs-line"></i><b>预告明日{{tomorrow_num}}场比赛</b>
                </template>
                <div :class="{'matchs-num':true,'none':type==18 || type==17 || type==16 || type==15||type==21||type==22}">{{daytxt}}{{current_time}}(共{{today.length}}场) <i :class="{'icon':true,'i_calendar':true,'none':isSelect!=1}" onClick={self.openCalendar.bind(self)}></i></div>
                <!-- {/* 冷门等模型 */} -->
                <div :class="{'matchs-num':true,'none':type!=18 && type!=17 && type!=16 && type!=15&&type!=21&&type!=22 || ((type==16||type==15||type==21||type==22)&&modelActive==2&&(info.status==0||info.status==-1||info.status==3))}"><span :class="{'none':!(type==16&&modelActive==2)}">今日</span>{{coldtime}}(共{{coldList && coldList.length}}场) <i :class="{'icon':true,'i_calendar':true,'none':type==16&&modelActive==2}" onClick={self.openCalendar.bind(self)}></i></div>
            </div>
            <!-- {/* ai智篮tab切换 */} -->
            <div :class="{'ai-tab':true, 'none':type!=6}">
                <div>
                    <span :class="isActive==1? 'active':''">热门推荐<em></em></span>
                </div>
                <div onClick={self.switchAiTab.bind(self,2)}>
                    <span :class="isActive==2? 'active':''">购买历史<em></em></span>
                </div>
            </div>
            <!-- {/* 情报模型tab切换 */} -->
            <template v-if="inteDown">
                <div :class="{'intelligence-tab':true}">
                    <div class="recommend-total">推荐总数：{{inteRecommendTotal}}条 {{inteRecommendTime ? (inteRecommendTime+'更新') : ''}}</div>
                    <div class="screen-parent clearfloat">
                        <div class="match-state">
                            <span class="tab-name">赛事状态</span>
                            <span class="inte-state clearfloat" ref="intestateshow" onClick={self.showIntMatchWindow.bind(self)}>{{inteMatchStateText}}<i class="triangle fl-r"></i></span>
                            <!-- {/* 时间切换弹窗 */} -->
                            <div :class="{'month-drop': true}" ref="intematchwindow">
                                <ul class="intestateul" ref="intematchstatelist" onClick={self.changeInteMatchState.bind(self)}>
                                    <li :class="{'active':inteMatchStateText == '全部'}" data-value="0" data-key="全部">全部</li>
                                    <li :class="{'active':inteMatchStateText == '已完赛'}" data-value="-1" data-key="已完赛">已完赛</li>
                                    <li :class="{'active':inteMatchStateText == '未完赛'}" data-value="1" data-key="未完赛">未完赛</li>
                                    <li :class="{'active':inteMatchStateText == '无关联'}" data-value="2" data-key="无关联">无关联</li>
                                </ul>
                            </div>
                        </div>
                        <div class="type-state">
                            <span class="tab-name">情报类型</span>
                            <span class="inte-state clearfloat" ref="typestateshow" onClick={self.showIntTypeWindow.bind(self)}>{{inteTypeStateText}}<i class="triangle fl-r"></i></span>
                            <!-- {/* 时间切换弹窗 */} -->
                            <div :class="{'month-drop': true}" ref="intetypewindow">
                                <ul class="intestateul" ref="intetypestatelist" onClick={self.changeInteTypeState.bind(self)}>
                                    <li :class="{'active':inteTypeStateText == '全部'}" data-value="0" data-key="全部">全部</li>
                                    <template v-if="raderTypes && raderTypes.length > 0">
                                        <li v-for="item in raderTypes" :key="item.id" :class="{'active':inteTypeStateText == item.name}" data-value={item.id} data-key={item.name}>{{item.name}}</li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <!-- {/* 其他5种模型列表 */} -->
            <div :class="{'daily-list': true, 'bg1': !(today.length === 0), 'none': loading || type==6 || type==18 || type==17 || type==16 || type==15 || type==19 || type == 20||type==21||type==22}">
                <div class="daily-package daily-2 nobg">
                    <ul>
                        <li class="daily-package-item no1">
                            <template v-if="today.length > 0">
                                <div v-for="(item,index) in today" :key="index" class="package-dec dec_1" onClick={self.goMatchLive.bind(self,item.matchId)}>
                                    <div class="package-team info">
                                        <span class="league" :style="{color: item.sclass_color}">{{item.sclass_name}}</span><span class="time">{{item.match_time.replace(/(^\d{4}\-|\:\d{2}$)/g, "").replace(/\-(\d{2})/g, "月$1日")}}</span>
                                    </div>
                                    <div class="package-team sub">
                                        <template v-if="item.type == '4'">
                                            <strong v-if="item.show_team == '1'">{{item.home_team}}</strong>
                                            <strong v-else>{{item.guest_team}}</strong>
                                        </template>
                                        <template v-else>
                                            <strong>{{item.home_team}}<span>{{item.homeWholeGoals ? item.homeWholeGoals+':'  : ''}}{{item.awayWholeGoals || ''}}</span>{{item.guest_team}}</strong>
                                        </template>
                                    </div>
                                    <div :class="{'package-team': true, 'des': true, 'limit': item.type == '4'}">
                                        <template v-for="(is,ins) in item.text.split('!')">
                                            <p :key="ins">{{item.text.split("!")[ins]}}</p>
                                        </template>
                                        <p v-if="item.type == '3' || item.type == '5'" class="odds">注：欧指指数来自365</p>
                                    </div>
                                    <!-- {svg}  ??????????????暂时不做 -->
                                </div>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- {/* 冷门模型列表 */} -->
            <!-- {} -->
            <div :class="{'daily-list': true, 'bg1': coldList&&coldList.length != 0 && (modelActive==1 || (modelActive==2&& info.status != -1&& info.status != 0&& info.status != 3)), 'none': loading || (type!=18&&type!=17&&type!=16&&type!=15&&type!=21&&type!=22)}">
                <div class="daily-package daily-2 nobg">
                    <ul>
                        <li class="daily-package-item no1">
                            <template v-if="modelActive == 2 && (info.status==-1 ||info.status==0 || info.status == 3)">
                                <div class="daily-find">
                                    <i class="daily-no-find"></i>
                                    <p>您目前暂未订购该模型，仅可查看往日推荐内容，<span class="gonow" onClick={self.go_daily_buy.bind(self, type, false)}>赶快去订购吧！</span></p>
                                </div>
                            </template>
                            <template v-else-if="coldList">
                                <template v-if="coldList.length > 0">
                                    <template v-if="type == 16 && modelActive == 1">
                                        <div class="package-dec dec_full">
                                            <div class="full-tips">各玩法命中数</div>
                                            <span class="fulldimenpre">胜平负：<cite>{{fullpre_total.standard_count}}</cite>场</span><span class="fulldimenpre">亚指让球：<cite>{{fullpre_total.letgoal_count}}</cite>场</span><span class="fulldimenpre">大小球：<cite>{{fullpre_total.totalscore_count}}</cite>场</span>
                                        </div>
                                    </template>
                                    <template v-for="(item,index) in coldList">
                                        <template v-if="type == 15 || type == 16 || type == 21||type==22">
                                            <template v-if="type == 21">
                                                <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self,item)}>
                                                    <div class="package-team info">
                                                        <span class="league" style={{color: item.sclass_color}}>{item.sclass_name}</span><span class="time">{match_time}</span>
                                                    </div>
                                                    <div class="match-team-result">
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img src={match_home_logo} /></div>
                                                            <div class="team-name">{{item.home_team}}</div>
                                                        </div>
                                                        {odds_team_vs}
                                                        <div class="match-col">
                                                            <div class="wave-team-logo"><img src={match_away_logo} /></div>
                                                            <div class="team-name">{item.guest_team}</div>
                                                        </div>
                                                        <div></div>
                                                        {odds_result}
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-else-if="type == 18">
                                            <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self, item)}>
                                                <div class="package-team info">
                                                    <span class="league" style={{color: item.sclass_color}}>{item.sclass_name}</span><span class="time">{match_time}</span>
                                                </div>
                                                <div class="package-team sub">
                                                    {arr_team_vs}
                                                </div>
                                                <div :class="{'package-team': true, 'des': true}">
                                                    <p>{item.msg}</p>
                                                </div>
                                                {coldsvg}
                                            </div>
                                        </template>
                                        <template v-else-if="type == 17">
                                            <div :key="index" class="package-dec dec_1" onClick={self.goDataModelDetail.bind(self, item)}>
                                                <div class="package-team info">
                                                    <span class="league" style={{color: item.sclass_color}}>{item.sclass_name}</span><span class="time">{match_time}</span>
                                                </div>
                                                <div class="match-team-result">
                                                    <div class="match-col">
                                                        <div class="wave-team-logo"><img src={match_home_logo} /></div>
                                                        <div class="team-name">{item.home_team}</div>
                                                    </div>
                                                    {odds_team_vs}
                                                    <div class="match-col">
                                                        <div class="wave-team-logo"><img src={match_away_logo} /></div>
                                                        <div class="team-name">{item.guest_team}</div>
                                                    </div>
                                                    {odds_result}
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="daily-find">
                                        <i class="daily-no-find"></i>
                                        <p>暂无数据!</p>
                                    </div>
                                </template>
                            </template>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- {/* ai智篮分析列表 */} -->
            <div :class="{'ai-list': aibasketList && aibasketList.length > 0, 'none':type!=6, 'closeai':closeAi}">
                <template v-if="closeAi">
                    <div class="daily-find">
                        <i class="daily-no-find"></i>
                        <p>当前nba赛事均已停赛，具体开赛时间以nba官方为准。去看其他模型～</p>
                    </div>
                </template>
                <template v-else-if="noai && aibasketList">
                    <template v-if="aibasketList && aibasketList.length > 0">
                        <div v-for="(item,index) in aibasketList" :key="index" class="ai-li clearfloat">
                            <div class="league fl-l">
                                <p>{{item.league_name_j}}</p>
                                <p>{{item.match_time.split(" ")[0].substr(5)}}</p>
                                <p>{{item.match_time.split(" ")[1].substr(0,5)}}</p>
                                </div>
                            <div class="team fl-l">
                                <template v-if="getCookies('bkb_away') == 1">
                                    <p><span>[客]</span><strong>{{item.away_name_j}}</strong></p>
                                    <p><span>[主]</span><strong>{{item.home_name_j}}</strong></p>
                                </template>
                                <template v-else>
                                    <p><span>[主]</span><strong>{{item.home_name_j}}</strong></p>
                                    <p><span>[客]</span><strong>{{item.away_name_j}}</strong></p>
                                </template>
                            </div>
                            <div class="score fl-l">
                                <template v-if="getCookies('bkb_away') == 1">
                                    <p><strong>{{item.away_score || ''}}</strong></p>
                                    <p><strong>{{item.home_score || ''}}</strong></p>
                                </template>
                                <template v-else>
                                    <p><strong>{{item.home_score || ''}}</strong></p>
                                    <p><strong>{{item.away_score || ''}}</strong></p>
                                </template>
                            </div>
                            <div :class="{'btn':true,'fl-r':true,'disabled':btncss(item.status,item.match_state)=='-1','needbuy':btncss(item.status,item.match_state) == '0'}">
                                <div onClick={self.goBuyAibasket.bind(self,item)}>
                                    <template v-if="item.status == 1">
                                        详情
                                    </template>
                                    <template v-else-if="item.status == 2">
                                        免费试看
                                    </template>
                                    <template v-else>
                                        {{info.price + (hiscores ? "金币" : "嗨币")}}
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <!-- {/* 情报模型列表 */} -->
            <template v-if="type == 19 || type == 20">
                <div :class="{'intelligence-part': true, 'hide':type!=19 && type!=20}">
                    <template v-if="inteDown && !nologin && isJHApps() && behavior == 1">
                        <div class="free-inte-tips">恭喜您已获得24小时内的所有赛事情报+88元红包奖励，关注服务号，可第一时间获取最新情报哦~</div>
                    </template>
                    <template v-if="true || inteDown && !nologin">
                        <template v-if="intelligenceList && intelligenceList.length > 0">
                            <ul v-for="(item,index) in intelligenceList" :key="index" class="intelligence-list">
                                <!-- 足球 -->
                                <template v-if="item.match_type == 1">
                                    <template v-for="(zq,zqIns) in MatchListNewSet(zqIntelligence)">
                                         <div v-if="zq.matchID == item.match_id" :key="zqIns" class="intelligence-detail">
                                            <i :class="{'icon':true,'i_share':true,'singleinte':true,'none':type == 20 || getAppVs() < 350 || (item.is_open == '0' && !item.title) || hiscores}" onClick={self.shareSingleInte.bind(self,item,firstcolour,firstname,zq)}></i>
                                            <div class="inte-info">
                                                <span :class="{'inte-circle':true,'unread':item.unread}"></span>
                                                <span class="inte-time">{{item.create_time ? item.create_time.substring(2,16).replace(/-/g,'.') : ''}}</span>
                                                <!--  eslint-disable-next-line vue/valid-v-if -->
                                                <template v-if="item.inform_type && splitInit(item.inform_type,',').length > 0">
                                                    <!-- eslint-disable-next-line vue/valid-v-for -->
                                                    <template v-for="(is,ins) in splitInit(item.inform_type,',')">
                                                        <span :key="ins" class="inte-type" :style="{'background': intetype_obj()[is].colour || '#7D7D7D'}">{{intetype_obj()[is].name }}</span>
                                                    </template>
                                                </template>
                                            </div>
                                            <template v-if="item.is_open == '0' && !item.content">
                                                <div class="inte-content private-back">
                                                    <div class="private-txt"><i class="icon i_lock"></i>开通包月即可查看所有赛事情报哦~</div>
                                                    <p class="match-info clearfloat">
                                                        <span class="league fl-l">{{zq.leagueNameJ}}</span>
                                                        <span class="team">
                                                            <i class="name">{{zq.homeNameJ}}</i>
                                                            <i class="score unfinished">VS</i>
                                                            <i class="name">{{zq.awayNameJ}}</i>
                                                        </span>
                                                        <span class="time fl-r">
                                                            {{zq.matchTime ? zq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                        </span>
                                                    </p>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div class="inte-content" >
                                                    <h2 class="inte-title">{{item.title}}</h2>
                                                    <p class="inte-text">{{item.content}}</p>
                                                    <p :class="{'inte-img':true,'nopic':!item.picture}"><img :src="item.picture" /></p>
                                                    <p class="match-info clearfloat">
                                                        <span class="league fl-l">{{zq.leagueNameJ}}</span>
                                                        <span class="team">
                                                            <i class="name">{{zq.homeNameJ}}</i>
                                                            <i class="score unfinished">VS</i>
                                                            <i class="name">{{zq.awayNameJ}}</i>
                                                        </span>
                                                        <span class="time fl-r">
                                                            {{zq.matchTime ? zq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                        </span>
                                                    </p>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="item.match_type == 2">
                                    <template v-for="(lq,zqIns) in MatchListNewSet(lqIntelligenceList)">
                                        <div v-if="lq.matchID == item.match_id" :key="zqIns" class="intelligence-detail">
                                            <i :class="{'icon':true,'i_share':true,'singleinte':true,'none':type == 20 || getAppVs() < 350 || (item.is_open == '0' && !item.title) || hiscores}" onClick={self.shareSingleInte.bind(self,item,firstcolour,firstname,zq)}></i>
                                            <div class="inte-info">
                                                <span :class="{'inte-circle':true,'unread':item.unread}"></span>
                                                <span class="inte-time">{{item.create_time ? item.create_time.substring(2,16).replace(/-/g,'.') : ''}}</span>
                                                <template v-if="item.inform_type && splitInit(item.inform_type,',').length > 0">
                                                    <template v-for="(is,ins) in splitInit(item.inform_type,',')">
                                                        <span :key="ins" class="inte-type" :style="{background: intetype_obj()[is].colour || '#7D7D7D'}">{{intetype_obj()[is].name }}</span>
                                                    </template>

                                                </template>
                                            </div>
                                            <template v-if="item.is_open == '0' && !item.content">
                                                <div class="inte-content private-back">
                                                        <div class="private-txt"><i class="icon i_lock"></i>开通包月即可查看所有赛事情报哦~</div>
                                                        <p class="match-info clearfloat">
                                                            <span class="league fl-l">{{lq.league_name_j}}</span>
                                                            <span class="team">
                                                                <i class="name">{{lq.home_name_j}}</i>
                                                                <i class="score unfinished">VS</i>
                                                                <i class="name">{{lq.away_name_j}}</i></span>
                                                            <span class="time fl-r">
                                                                {{lq.matchTime ? lq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                            </span>
                                                        </p>
                                                    </div>
                                            </template>
                                            <template v-else>
                                               <div class="inte-content" onClick={this.goMatchLiveFromInte.bind(this,item)}>
                                                    <h2 class="inte-title">{{item.title}}</h2>
                                                    <p class="inte-text">{{item.content}}</p>
                                                    <p :class="{'inte-img':true,'nopic':!item.picture}"><img :src="item.picture" /></p>
                                                    <p class="match-info clearfloat">
                                                        <span class="league fl-l">{{lq.league_name_j}}</span>
                                                        <span class="team">
                                                            <i class="name">{{lq.home_name_j}}</i>
                                                            <i class="score unfinished">VS</i>
                                                            <i class="name">{{lq.away_name_j}}</i></span>
                                                        <span class="time fl-r">
                                                            {{lq.matchTime ? lq.matchTime.substring(2,16).replace(/-/g,'.') : ''}}
                                                        </span>
                                                    </p>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="intelligence-detail">
                                        <i :class="{'icon':true,'i_share':true,'singleinte':true,'none':type == 20 || getAppVs() < 350 || (item.is_open == '0' && !item.title) || hiscores}" onClick={self.shareSingleInte.bind(self,item,firstcolour,firstname,zq)}></i>
                                            <div class="inte-info">
                                            <span :class="{'inte-circle':true,'unread':item.unread}"></span>
                                            <span class="inte-time">{{item.create_time ? item.create_time.substring(2,16).replace(/-/g,'.') : ''}}</span>
                                            <template v-if="item.inform_type && splitInit(item.inform_type,',').length > 0">
                                                <template v-for="(is,ins) in splitInit(item.inform_type,',')">
                                                    <span :key="ins" class="inte-type" :style="{background: intetype_obj()[is].colour || '#7D7D7D'}">{{intetype_obj()[is].name }}</span>
                                                </template>

                                            </template>
                                        </div>
                                        <template v-if="item.is_open == '0' && !item.content">
                                            <div class="inte-content private-back">
                                                <div class="private-txt nomatch"><i class="icon i_lock"></i>开通包月即可查看所有赛事情报哦~</div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="inte-content irrelevant" onClick={this.openUrlInApp.bind(this,item)}>
                                                <h2 class="inte-title">{{item.title}}</h2>
                                                <p class="inte-text">{{item.content}}</p>
                                                <p :class="{'inte-img':true,'nopic':!item.picture}"><img :src="item.picture" /></p>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                            </ul>
                        </template>
                        <template v-else>
                            <ul class="intelligence-nologin">
                                <i class="daily-no-find"></i>
                                <p>暂无数据!</p>
                            </ul>
                        </template>
                    </template>
                    <template v-else>
                        <div class="intelligence-nologin">
                            <p class="logintxt">登录后可查看数据情报</p>
                            <p class="loginbtn" onClick={self.gotoLogin.bind(self)}>登录</p>
                        </div>
                    </template>
                </div>
            </template>

            <!-- {/* 情报、雷达底部常驻购买入口 */} -->
            <div :class="{'vipBox':true,'none':type != 19 && type != 20}">
                <div class="vipBtn">
                    <p onClick={self.go_daily_buy.bind(self,type,false)}>{{(info.status == 1 || info.status == 2) ? '续费' : (type == 19 ? '开通即可查看全部' : '立即开通')}}</p>
                    <p class="locked">累计{{buy_info.total}}人解锁</p>
                </div>
            </div>
            <!-- {/* 日历 */} -->
            <!-- <Calendar
                show={showCalendar}
                startTime={startTime}
                endTime={endTime}
                current_time={current_time}
                close={this.closeCalendar.bind(this)}
                callback={this.updateDailyDate.bind(this)}
            /> -->
        </div>
    </div>
</template>

<script>
import { isWeiXin, urlQuery, setTitle, formatDate, getlocalStorage, isHiscores, isStorepack, getAppV, formatNum, getCookie, isJHApp } from "../../utils/base.js"
import Down from "../../components/programme/appdown.vue"
import mutil from "../../utils/mutil"
import { getIntelligenceListApi, getDataTypeListApi, getInformLevelApi, getRaderListApi, getColdHisApi, getForwardApi } from "../../api/modelTemporary"
import { shareinit } from "../../utils/share"
export default {
    name: "information",
    components: {
        Down
    },
    data () {
        return {
            // 数据模型价格
            dataPrice: {
                1: 30,
                2: 30,
                3: 98,
                4: 30,
                5: 30,
                18: 198,
                17: 198,
                16: 198,
                15: 298,
                19: 598,
                20: 298,
                21: 198,
                22: 198
            },
            // 未定义？？？
            coldtime: '',
            // 数据模型title
            dataTitleList: {
                1: '大热',
                2: '悬殊',
                3: '同赔',
                4: '极限',
                5: '庄家态度',
                6: 'Ai智篮分析',
                15: '大数据报告',
                16: '全维预测',
                17: '指数波动',
                18: '冷门分析',
                19: '情报速递',
                20: '数据雷达',
                21: '泊松分布',
                22: '超级必发'
            },
            closeAi: false,
            isScroll: true,
            dailyMap: mutil.dailyMap,
            // 2
            showCalendar: false,
            today: [], // 默认数据
            tomorrow_num: 0, // 预计明日
            current_time: '',
            start_time: '',
            end_time: "",
            daytxt: "",
            info: {
                // name: "",
                // description: "",
                // status: "",
                // endTime: ""
            },
            buy_info: {
                total: 0, // 购买数据用户列表
                avatar: [] // 购买数据总人数
            },
            // 1
            type: this.$route.query.type,
            loading: true,
            isSelect: 1,
            onlineIsAuto: false, // 商城包是否已开通自动续费
            isActive: 1, // ai智篮分析tab高亮
            modelActive: "", // 数据模型tab高亮
            commandActive: 1, // 数据模型今日推荐tab高亮
            coldList: [], // 数据模型列表
            modelupdatetime: [], // 数据模型今日推荐更新时间
            aibasketList: "",
            noai: false,
            nologin: false,
            // 1
            fullpre_total: {}, // 全维预测总数
            intelligenceList: [], // 情报列表
            zqIntelligence: [], // 足球情报
            lqIntelligenceList: [], // 篮球情报
            intelligenceType: [], // 情报类型列表
            moreinte_lock: false,
            currentPage: 1,
            pageCount: 1,
            inteMatchStateText: "全部", // 默认情报赛事状态文案
            inteTypeStateText: "全部", // 默认情报类型状态文案
            inteMatchState: "0", // 默认情报赛事状态
            inteTypeState: "0", // 默认情报类型状态
            showintematch: false, // 情报赛事状态弹窗
            showintetype: false, // 情报类型状态弹窗
            inteRecommendTotal: 0, // 情报推荐总数
            inteRecommendTime: "", // 情报推荐更新时间
            intelistids: [],
            inteDown: 0, // 情报接口是否加载完毕
            // 4
            behavior: "",
            raderlistids: [], // 雷达
            raderTypes: [], // 雷达类型
            hiscores: 0 // 嗨比分
        }
    },
    created () {
        this.$route.query.type = 20
        // eslint-disable-next-line eqeqeq
        if (this.behavior == "1") {
            // _czc.push(['_trackEvent', '情报裂变活动', '注册']); ??? 无法理解
        }
        const type = urlQuery("type") || "";
        // self.httpUserInfo();
        // self.iosIsAutoPay();
        this.getDataTypeList();
        // eslint-disable-next-line eqeqeq
        if (type && type == "19") {
            window.addEventListener("scroll", this.listScroll())
            var getLastIntelligenceIds = getlocalStorage("lastIntelligenceIds") || "";
            if (getLastIntelligenceIds) {
                var inteIdArr = JSON.parse(getLastIntelligenceIds);
                this.intelistids = inteIdArr
            }
        }
        // eslint-disable-next-line eqeqeq
        if (type && type == "20") {
            window.addEventListener("scroll", this.listScroll())
            var getLastRaderIds = getlocalStorage("lastRaderIds") || "";
            if (getLastRaderIds) {
                var raderIdArr = JSON.parse(getLastRaderIds);
                this.raderlistids = raderIdArr
            }
            this.$nextTick(() => {
                this.initRaderCard();
            })
        }
        // 嗨比分
        if (isHiscores()) {
            this.hiscores = 1
        }
    },
    methods: {
        isJHApps () {
            return isJHApp()
        },
        // 足球篮球去重
        MatchListNewSet (item, type) {
            // debugger
            var OriginIds = [];// 足球ids
            var MatchList = [];// 去重足球list
            if (item && item.length > 0) {
                item.forEach(zqitem => {
                    if (OriginIds.indexOf(zqitem.matchID) > -1) {
                        // 重复不予添加到list
                    } else {
                        MatchList.push(zqitem);
                    }
                    OriginIds.push(zqitem.matchID);
                });
            }
            // eslint-disable-next-line eqeqeq
            if (type == 'id') {
                return OriginIds
            } else {
                return MatchList
            }
        },
        splitInit (item, type) {
            return item.split(type)
        },
        intetype_obj () {
            // eslint-disable-next-line camelcase
            var intetype_obj = {};
            if (this.intelligenceType && this.intelligenceType.length > 0) {
                this.intelligenceType.forEach(intetype => {
                    // eslint-disable-next-line camelcase
                    var intetype_id = intetype.id;
                    // eslint-disable-next-line camelcase
                    var intetype_name = intetype.name;
                    // eslint-disable-next-line camelcase
                    var intetype_color = intetype.colour;
                    intetype_obj[intetype_id] = {
                        name: intetype_name,
                        colour: intetype_color
                    }
                })
            }
            // eslint-disable-next-line camelcase
            return intetype_obj
        },
        btncss (one, two) {
            // 按钮样式
            // eslint-disable-next-line eqeqeq
            if (one == 1) {
                return "1";
            // eslint-disable-next-line eqeqeq
            } else if (one == 2) {
                return "1";
            } else {
                // eslint-disable-next-line eqeqeq
                if (two > 0 || two == -1) {
                    return "-1";
                } else {
                    return "0";
                }
            }
        },
        getCookies (key) {
            return getCookie(key)
        },
        isHiscoress () {
            return isHiscores()
        },
        diffDay () {
            // eslint-disable-next-line eqeqeq
            if (this.info.status == 2) {
                // 情报时间精确到时分秒
                // eslint-disable-next-line eqeqeq
                if (this.type == 19) {
                    var standtime = this.info.end_time.replace(/-/g, '/');
                    var diffTime = (new Date(standtime).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
                    var difftime = formatNum(diffTime, 2) * 1;
                    var difftime2 = Math.ceil(diffTime);
                    if (difftime < 1) {
                        return "";
                    } else {
                        return "(剩余" + difftime2 + "天)";
                    }
                } else {
                    // eslint-disable-next-line no-redeclare
                    var standtime = this.info.end_time.replace(/-/g, '/');
                    // eslint-disable-next-line no-redeclare
                    var diffTime = (new Date(standtime).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24;
                    // eslint-disable-next-line no-redeclare
                    var difftime = Math.ceil(diffTime);
                    return "(剩余" + difftime + "天)";
                }
            }
        },
        getAppVs () {
            return getAppV()
        },
        isStorepacks () {
            return isStorepack()
        },
        // 雷达卡片
        initRaderCard () {
            // 1. 获取元素
            var focus = document.querySelector('.focus');
            var ul = focus.children[0];
            var ol = focus.children[1];
            // 获得focus的宽度
            var w = focus.offsetWidth;
            // 2. 利用定时器自动轮播图片
            var index = 0;
            var timer = setInterval(function () {
                index++;
                var translateX = -index * w;
                // 添加动画效果
                ul.style.transition = 'all .3s';
                ul.style.transform = 'translateX(' + translateX + 'px)';
            }, 5000);
            // 等着过渡完成之后，再去判断，监听过渡完成的事件transitionend
            ul.addEventListener('transitionend', function () {
                // 无缝滚动
                if (index >= 3) {
                    index = 0;
                    // 去掉过渡效果，这样让ul快速的跳到目标位置
                    ul.style.transition = 'none';
                    // 利用最新的索引号乘以宽度，继续滚动图片
                    var translateX = -index * w;
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                } else if (index < 0) {
                    index = 2;
                    // 去掉过渡效果，这样让ul快速的跳到目标位置
                    ul.style.transition = 'none';
                    // 利用最新的索引号乘以宽度，继续滚动图片
                    // eslint-disable-next-line no-redeclare
                    var translateX = -index * w;
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                }
                // 3. 小圆点跟随变化
                // 把ol里面li带有current类名的选出来，去掉类名remove
                ol.querySelector('.current').classList.remove('current');
                // 让当前索引号的li加上current类名add
                ol.children[index].classList.add('current');
            });
            // 4. 手指滑动轮播图
            // 触摸元素touchstart：获取手指初始坐标
            var startX = 0;
            var moveX = 0; // 后面会使用这个移动距离，所以要定义为全局变量
            var flag = false; // 用来标志手指是否真的移动，还是只是点击
            ul.addEventListener('touchstart', function (e) {
                startX = e.targetTouches[0].pageX;
                // 手指触摸的时候就停止定时器
                clearInterval(timer);
            });
            // 移动手指touchmove：计算手指的滑动距离，并且移动盒子
            ul.addEventListener('touchmove', function (e) {
                // 计算移动距离
                // e.targetTouches[0]为第一个手指，[1]表示第二个手指
                moveX = e.targetTouches[0].pageX - startX;
                // 移动盒子：盒子原来的位置 + 手指移动的距离
                var translateX = -index * w + moveX;
                // 手指拖动的时候，不需要动画效果，所以要取消过渡效果
                ul.style.transition = 'none';
                ul.style.transform = 'translateX(' + translateX + 'px)';
                flag = true;
                e.preventDefault(); // 组织滚动屏幕的行为
            });
            // 手指离开，根据移动距离去判断是回弹还是播放上一张或者下一张
            ul.addEventListener('touchend', function (e) {
                // 只有手指移动过了，才执行下面的代码
                if (flag) {
                    // （1）如果移动距离大于50像素，则播放上一张或者下一张
                    if (Math.abs(moveX) > 50) {
                        // 如果是右滑就是播放上一张，moveX是正值
                        if (moveX > 0) {
                            index--;
                        } else {
                            // 如果是左滑就是播放下一张，moveX是负值
                            index++;
                        }
                        // 用最新的index乘以宽度
                        var translateX = -index * w;
                        ul.style.transition = 'all .3s';
                        ul.style.transform = 'translateX(' + translateX + 'px)';
                    } else {
                        // （2）如果移动距离小于50像素就回弹
                        // eslint-disable-next-line no-redeclare
                        var translateX = -index * w;
                        ul.style.transition = 'all .1s';
                        ul.style.transform = 'translateX(' + translateX + 'px)';
                    }
                }
                // 手指离开的时候就重新开启定时器
                // 注意：开启定时器之前要先清空之前的定时器，保证当前只有一个定时器在执行
                clearInterval(timer);
                timer = setInterval(function () {
                    index++;
                    var translateX = -index * w;
                    // 添加动画效果
                    ul.style.transition = 'all .3s';
                    ul.style.transform = 'translateX(' + translateX + 'px)';
                }, 5000);
            });
        },
        // 更多情报分页
        moreIntelligence () {
            const type = urlQuery("type") || "19";
            // 最后一页
            // eslint-disable-next-line eqeqeq
            if (this.currentPage == this.pageCount * 1) {
                this.isScroll = false;
                return;
            }
            // eslint-disable-next-line eqeqeq
            if (this.pageCount * 1 == 0) {
                this.isScroll = false;
                return;
            }
            var nextPage = this.currentPage * 1 + 1;
            if (nextPage >= this.pageCount * 1) {
                nextPage = this.pageCount;
            }
            this.currentPage = nextPage
            // eslint-disable-next-line eqeqeq
            if (type == 19) {
                this.getIntelligenceList();
            } else {
                this.getRaderList();
            }
        },
        // 分页条件
        needScrollLoad () {
            if (this.moreinte_lock) {
                return;
            }
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            var clientHeight = window.innerHeight;
            return (clientHeight + scrollTop) - scrollHeight >= -10
        },
        // 分页
        listScroll (e) {
            if (!this.isScroll) {
                return;
            }
            if (this.needScrollLoad()) {
                this.moreinte_lock = true
                this.moreIntelligence();
            }
        },
        isWeixins () {
            return isWeiXin()
        },
        // 数据列表页
        async getDataTypeList (year, month, day, tab, cold) {
            const jsons = {};
            const type = urlQuery("type") || "1";
            let time = urlQuery("time") || "";
            // 320之前版本ios做区分
            const src = urlQuery("src") || "";
            var iosArr = [];
            var iosVersion = 0;
            if (src.indexOf("ios_AppStore") > -1 && src.indexOf("hiscores") < 0) {
                iosArr = src.split("_");
            } else {
                iosArr = [];
            }
            if (iosArr && iosArr.length > 0) {
                iosVersion = iosArr[2];
            } else {
                iosVersion = 0;
            }
            jsons.type = type;
            // eslint-disable-next-line eqeqeq
            if (type != 18) {
                jsons.tab = tab || "r";
            }
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            if (time) {
                jsons.time = time;
            }
            setTitle(mutil.dailyMap[type + '']);
            // eslint-disable-next-line eqeqeq
            if (type && type == 6) {
                if (jsons.tab === "r" && iosVersion && iosVersion * 1 < 320) {
                    this.closeAi = true;
                } else {
                    this.closeAi = false;
                }
                const data = await getDataTypeListApi(jsons)
                // eslint-disable-next-line eqeqeq
                if (data && data.errno == '0') {
                    var daily = data.data;
                    this.aibasketList = daily
                    this.buy_info = {
                        total: data.buy_info.total,
                        avatar: data.buy_info.avatar
                    }
                    this.info = {
                        name: data.info.name,
                        description: data.info.description,
                        status: data.info.status || "6",
                        endTime: data.info.endTime || "",
                        tags: data.info.tags,
                        price: data.info.price || ""
                    }
                    this.loading = false
                    this.noai = true
                    // const linkUrl = document.URL + "&invite_id=" + data.invite_id;
                    // var shareobj = {
                    //     title: '即嗨正当红大数据模型！——' + (this.dataTitleList[type]) + '，当前已有' + (this.buy_info && this.buy_info.total) + '人订阅',
                    //     desc: "最高预测命中率达91%！来“即嗨”，看赛事数据！",
                    //     link: linkUrl,
                    //     imgUrl: "https://s.jihaimall.com/h5/image/jhtylogo.png"
                    // }
                    // share.shareinit(shareobj);
                }
            } else {
                const data = await getDataTypeListApi(jsons)
                // eslint-disable-next-line eqeqeq
                if (data && data.errno == '0') {
                    // eslint-disable-next-line no-redeclare
                    var daily = data.data;
                    var startTime = "";
                    var endTime = "";
                    var coldcurTime = "";

                    var sTime = new Date(daily.curDate.split('-').join('/')).getTime();
                    var cc = new Date().getFullYear() + '/' + (new Date().getMonth() * 1 + 1) + '/' + new Date().getDate();
                    var cTime = new Date(cc).getTime();

                    var today = new Date();
                    var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                    var todaynow = now[0] + "-" + now[1] + "-" + now[2];
                    // eslint-disable-next-line eqeqeq
                    if (type != 18 && type != 17 && type != 16 && type != 15 && type != 21 && type != 22) {
                        if (sTime < cTime) {
                            this.isSelect = 1
                        // eslint-disable-next-line eqeqeq
                        } else if (sTime == cTime) {
                            this.isSelect = 2
                        } else {
                            this.isSelect = 3
                        }
                        if (daily.time) {
                            startTime = daily.time.startTime;
                            endTime = daily.time.endTime;
                        } else {
                            startTime = daily.curDate;
                            endTime = todaynow;
                        }
                    } else {
                        // 冷门
                        startTime = todaynow;
                        endTime = todaynow;
                        coldcurTime = todaynow;
                    }
                    this.today = daily.todayData
                    this.tomorrow_num = daily.tomorrowDataNum

                    this.current_time = coldcurTime || daily.curDate
                    this.daytxt = daily.day

                    this.startTime = startTime
                    this.endTime = endTime
                    this.coldtime = startTime

                    this.buy_info = {
                        total: data.buy_info.total,
                        avatar: data.buy_info.avatar
                    }
                    this.info = data.info
                    // this.info.description = data.info.description
                    // this.info.status = data.info.status
                    // this.info.endTime = data.info.endTime
                    // this.info.tags = data.info.tags
                    // this.info.names = data.info.name

                    this.type = type
                    this.loading = false
                    // eslint-disable-next-line eqeqeq
                    if (type == 18 || type == 17 || type == 16 || type == 15 || type == 21 || type == 22) {
                        var savedate = window.sessionStorage.getItem("savedate") || "";
                        if (savedate) {
                            // eslint-disable-next-line no-sequences
                            this.modelActive = 1
                            this.coldtime = savedate
                            this.current_time = savedate
                            this.dataModelList(1, null, null, null, null, null, savedate);
                        // eslint-disable-next-line eqeqeq
                        } else if (this.info.status == 0 || this.info.status == -1 || this.info.status == 3) {
                            this.modelActive = 1
                            this.dataModelList(1);
                        } else {
                            this.modelActive = 2
                            this.dataModelList(2);
                        }
                    // eslint-disable-next-line eqeqeq
                    } else if (type == 19) {
                        this.getInformLevel();
                    // eslint-disable-next-line eqeqeq
                    } else if (type == 20) {
                        this.getInformLevel();
                    } else {
                        this.svgCircle();
                    }
                    const linkUrl = document.URL + "&invite_id=" + data.invite_id;
                    var desc = "最高预测命中率达91%！来“即嗨”，看赛事数据！";
                    // eslint-disable-next-line eqeqeq
                    if (type == 20) {
                        desc = '全网最快一手数据！来“即嗨”看赛事数据！';
                    }
                    var shareobj = {
                        title: '即嗨正当红大数据模型！——' + (this.dataTitleList[type]) + '，当前已有' + (this.buy_info && this.buy_info.total) + '人订阅',
                        desc: desc,
                        link: linkUrl,
                        imgUrl: "https://s.jihaimall.com/h5/image/jhtylogo.png"
                    }
                    // shareType 1表示邀请好友的分享，2表示可以分享到小程序
                    // eslint-disable-next-line eqeqeq
                    if (type == 19 && !this.hiscores) {
                        shareobj.wechatMiniId = "gh_daa6378f14c9";
                        shareobj.path = "pages/newspush/newspush";
                        shareobj.shareType = 2;
                        shareinit(shareobj);
                    }
                }
            }
        },
        // 环形图
        svgCircle () {
            // svg
            const donutSvgPath = document.querySelectorAll(".donutSvgPath");
            const donutSvgR = document.querySelectorAll(".donutSvgR");
            for (var m = 0; m < donutSvgPath.length; m++) {
                const svgPath = donutSvgPath[m];
                const svgR = donutSvgR[m];
                const $path = svgPath.getElementsByTagName("circle");
                for (var n = 0; n < $path.length; n++) {
                    const pathCircle = $path[n];
                    const r = (svgPath.offsetWidth * 1 - svgR.offsetWidth * 1) / 2;
                    const cx = svgPath.offsetWidth * 1 / 2;
                    const cy = svgPath.offsetWidth * 1 / 2;
                    pathCircle.setAttribute("r", r);
                    pathCircle.setAttribute("cx", cx);
                    pathCircle.setAttribute("cy", cy);
                    pathCircle.setAttribute("fill", "none");
                    pathCircle.setAttribute("stroke-width", svgR.offsetWidth * 1);
                    // eslint-disable-next-line eqeqeq
                    if (n == 1) {
                        const perimeter = 2 * Math.PI * r;
                        const rangeValue = pathCircle.getAttribute("data-percent") * 1;
                        const radio = perimeter - (rangeValue / 100) * perimeter
                        pathCircle.style.strokeDasharray = pathCircle.style.strokeDashoffset = perimeter;
                        pathCircle.style.transition = "stroke-dashoffset 600ms ease-in-out";
                        pathCircle.style.strokeDashoffset = radio;
                    }
                }
            }
        },
        // 获取雷达类型列表
        async getInformLevel () {
            const type = urlQuery("type") || "19";
            var informModel = 2;
            // eslint-disable-next-line eqeqeq
            if (type == 19) {
                informModel = 1;
            }
            const data = await getInformLevelApi({ informModel: informModel })
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                this.raderTypes = data.data
                // eslint-disable-next-line eqeqeq
                if (type == 19) {
                    this.getIntelligenceList();
                } else {
                    this.getRaderList();
                }
            }
        },
        // 获取雷达列表
        async getRaderList () {
            const type = urlQuery("type") || "20";
            const params = {
                type: type,
                match_state: this.inteMatchState || "",
                inform_type: this.inteTypeState || "",
                page: this.currentPage
            }
            const data = await getRaderListApi(params)
            // eslint-disable-next-line eqeqeq
            if (data && data.errno == '0') {
                var intedata = data.data;
                // eslint-disable-next-line eqeqeq
                if (this.currentPage == 1) {
                    this.zqIntelligence = intedata.zq_match || []
                    this.lqIntelligenceList = intedata.lq_match || []
                    this.intelligenceType = intedata.information_type || []
                    this.intelligenceList = intedata.record || []
                    this.inteRecommendTotal = intedata.all_total || 0
                    this.inteRecommendTime = intedata.happened
                    this.currentPage = intedata.cur_page * 1
                    this.pageCount = intedata.page_count * 1
                    this.inteDown = 1
                } else {
                    this.zqIntelligence = this.zqIntelligence.concat(intedata.zq_match)
                    this.lqIntelligenceList = this.lqIntelligenceList.concat(intedata.lq_match)
                    this.intelligenceType = this.intedata.information_type
                    this.intelligenceList = this.intelligenceList.concat(intedata.record)
                    this.currentPage = intedata.cur_page * 1
                    this.pageCount = intedata.page_count * 1
                    this.inteDown = 1
                    this.moreinte_lock = false
                }
            }
        },
        // 获取冷门列表
        async dataModelList (tab, params, year, month, day, isdatamodel, record) {
            const type = urlQuery("type") || "1";
            let time = "";
            setTitle(mutil.dailyMap[type + '']);
            if (year && month && day) {
                if (day < 10) {
                    day = "0" + day;
                }
                if (month < 10) {
                    month = "0" + month;
                }
                time = year + "-" + month + "-" + day;
            }
            var savedate = window.sessionStorage.getItem("savedate") || "";
            if (record || savedate) {
                time = savedate;
            }
            var modeljsons = {};
            var modeljson1 = {
                day_time: time || ""
            }
            // eslint-disable-next-line eqeqeq
            if (type == 22 && tab == 1) {
                modeljson1 = {
                    data_type: type,
                    method: 'his',
                    day_time: time || ""
                }
            }
            var urlApi = ''
            // eslint-disable-next-line eqeqeq
            if (type == 18 || type == 17 || type == 16 || type == 15) {
                // eslint-disable-next-line eqeqeq
                if (type == 18) {
                    modeljsons = {
                        method: "data/oa/zq/analy/cold/schedule",
                        data_type: type,
                        order: params || "",
                        display_all: 1
                    };
                    modeljson1.display_all = 1;
                // eslint-disable-next-line eqeqeq
                } else if (type == 15) {
                    modeljsons = {
                        method: "data/oa/zq/analy/score/schedule",
                        data_type: type,
                        order: params || ""
                    };
                } else {
                    modeljsons = {
                        // eslint-disable-next-line eqeqeq
                        method: type == 17 ? "data/oa/zq/analy/dis/schedule" : "data/oa/zq/analy/full/schedule",
                        data_type: type,
                        order: params || ""
                    };
                }
                // '/data/oa/zq/analy/cold/his'
                urlApi = 1
            // eslint-disable-next-line eqeqeq
            } else if (type == 21 || type == 22) {
                modeljsons = {
                    jczc: 1,
                    method: "schedule",
                    data_type: type
                };
                // '/data/forward'
                urlApi = 2
            }
            // 历史命中
            // eslint-disable-next-line eqeqeq
            if (tab == 1) {
                let data = null
                if (urlApi === 1) {
                    data = await getColdHisApi(modeljsons)
                } else {
                    data = await getForwardApi(modeljsons)
                }
                // eslint-disable-next-line eqeqeq
                if (data && data.errno == '0') {
                    var coldhis = "";
                    // eslint-disable-next-line eqeqeq
                    if (type == 16) {
                        coldhis = data.data.result || [];
                        this.fullpre_total = data.data
                    } else {
                        coldhis = data.data;
                        // eslint-disable-next-line eqeqeq
                        if (type == 21) {
                            coldhis = data.data.list
                        }
                        // eslint-disable-next-line eqeqeq
                        if (type == 22) {
                            coldhis = data.data
                        }
                    }
                    // eslint-disable-next-line eqeqeq
                    if (isdatamodel == "isdatamodel") {
                        var today = new Date();
                        var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                        var todayNow = now[0] + "-" + now[1] + "-" + now[2];
                        this.coldtime = todayNow
                        this.current_time = todayNow
                    }
                    this.coldList = coldhis
                    this.loading = false
                    // eslint-disable-next-line eqeqeq
                    if (type == 15 || type == 21) {
                        this.svgCircle();
                    }
                }
            } else {
                // 今日推荐
                this.refs.jccheck.checked = false
                const data = await getForwardApi(modeljsons)
                // eslint-disable-next-line eqeqeq
                if (data && data.errno == '0') {
                    // eslint-disable-next-line eqeqeq
                    if (isdatamodel == "isdatamodel") {
                        // eslint-disable-next-line no-redeclare
                        var today = new Date();
                        // eslint-disable-next-line no-redeclare
                        var now = [formatDate(today, "yyyy"), formatDate(today, "MM"), formatDate(today, "dd")];
                        // eslint-disable-next-line no-redeclare
                        var todayNow = now[0] + "-" + now[1] + "-" + now[2];
                        this.coldtime = todayNow
                        this.current_time = todayNow
                    }
                    var todaydata = "";
                    // eslint-disable-next-line eqeqeq
                    if (type == 16) {
                        todaydata = data.data;
                    // eslint-disable-next-line eqeqeq
                    } else if (type == 21) {
                        todaydata = data.data.list
                    // eslint-disable-next-line eqeqeq
                    } else if (type == 22) {
                        todaydata = data.data
                    } else {
                        todaydata = data.data.result;
                    }
                    var commandtime;
                    if (data.data) {
                        commandtime = data.data.minutes || "";
                    }
                    this.coldList = todaydata
                    this.modelupdatetime = commandtime
                    this.loading = false
                    // eslint-disable-next-line eqeqeq
                    if (type == 18 || type == 16 || type == 15 || type == 21) {
                        this.svgCircle();
                    }
                }
            }
        },
        // 获取情报列表
        async getIntelligenceList () {
            const type = urlQuery("type") || "19";
            const params = {
                type: type,
                match_state: this.inteMatchState || "",
                inform_type: this.inteTypeState || "",
                page: this.currentPage
            }
            const res = await getIntelligenceListApi(params)
            // eslint-disable-next-line eqeqeq
            if (res && res.errno == '0') {
                var intedata = res.data;
                if (this.currentPage === 1) {
                    this.zqIntelligence = intedata.zq_match || []
                    this.lqIntelligenceList = intedata.lq_match || []
                    this.intelligenceType = intedata.information_type || []
                    this.intelligenceList = intedata.record || []
                    this.inteRecommendTotal = intedata.all_total || 0
                    this.inteRecommendTime = intedata.happened
                    this.currentPage = intedata.cur_page * 1
                    this.pageCount = intedata.page_count * 1
                    this.inteDown = 1
                } else {
                    this.zqIntelligence = this.zqIntelligence.concat(intedata.zq_match)
                    this.lqIntelligenceList = this.lqIntelligenceList.concat(intedata.lq_match)
                    this.intelligenceType = this.intedata.information_type
                    this.intelligenceList = this.intelligenceList.concat(intedata.record)
                    this.currentPage = intedata.cur_page * 1
                    this.pageCount = intedata.page_count * 1
                    this.inteDown = 1
                    this.moreinte_lock = false
                }
            }
        }
    }
}
</script>

<style>
@import url("../../assets/css/_discovery.min.css");
</style>
